import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { Segment } from '../../../../services/analytics-services/segment';
import { useShipmentUsageSummary } from '../../../purchase-shipment-volume/use-shipment-usage-summary';

export const useTrackShipmentVolumeEvent = () => {
  const billingPlanId = useSelector(Global.selectSellerSubscriptionPlanInfo)?.billingPlanId;
  const planName = useSelector(Global.selectSellerPlanInfo)?.plan?.name ?? '';
  const { shipmentLimit, totalUsage, usagePercentage, isAtLimit, isHighLimitWarning, isMediumLimitWarning, purchasedShipmentCount } =
    useShipmentUsageSummary();

  return useCallback(
    (eventName: string, metadata: Record<string, unknown> = {}) => {
      Segment.trackEvent(eventName, {
        ...metadata,
        billingPlanId,
        planName,
        shipmentLimit,
        totalUsage,
        usagePercentage,
        isAtLimit,
        isHighLimitWarning,
        isMediumLimitWarning,
        purchasedShipmentCount,
      });
    },
    [
      billingPlanId,
      planName,
      shipmentLimit,
      totalUsage,
      usagePercentage,
      isAtLimit,
      isHighLimitWarning,
      isMediumLimitWarning,
      purchasedShipmentCount,
    ],
  );
};
